<div class="wrap cf" *ngIf="showCropper">
    <div class="static-outer-wrap">
        <div #canvasWrap class="canvas-wrap" [ngClass]="{loading: loading}" style="width: {{ imageWidth }}">
            <canvas #canvasEl></canvas>
        </div>
        <span class="info cf">
            <span class="left">{{size.label}} ({{imageWidth}}x{{imageHeight}})</span>
            <span class="right" *ngIf="canEdit === true">
                <button *ngIf="cropped" (click)="restoreInitialCrop()"><mat-icon>refresh</mat-icon></button>
                <button (click)="zoom(true)"><mat-icon>zoom_in</mat-icon></button>
                <button (click)="zoom(false)"><mat-icon>zoom_out</mat-icon></button>
            </span>
        </span>
        <span *ngIf="imageService.isMobileOnlyImage(image) && (size.value == 'medium' || size.value == 'mobile')" class="error"><mat-icon>error_outline</mat-icon> Mobile only image</span>
        <span *ngIf="canvasError != ''" class="error"><mat-icon>error_outline</mat-icon> {{canvasError}}</span>
    </div>
</div>